// Utilities
import { ActionTree, MutationTree } from 'vuex';
import { set } from '../utils';

export interface SnackBarType {
  id?: string;
  icon: string;
  color: string;
  type: string;
  right: boolean;
  useBtn: boolean;
  msg: string;
  btnText: string;
  timeout: number;
  action: () => any;

  centered: false;
  href: false;
  to: false;
  btn: {
    to: any;
    href: any;
  };
}

export const DEFAULT_SNACKBAR = Object.freeze<Partial<SnackBarType>>({
  color: 'primary',
  centered: false,
  href: false,
  msg: '',
  btnText: 'Close',
  to: false,
  timeout: 6000,
  btn: {
    to: null,
    href: null
  },
  action: function() {}
});

export const state = {
  snackbar: {
    ...DEFAULT_SNACKBAR
  },
  value: false
};

type SnackbarState = typeof state;

export const mutations: MutationTree<SnackbarState> = {
  SET_SNACKBAR: (state: any, payload: SnackBarType) => {
    state.snackbar = Object.assign({}, DEFAULT_SNACKBAR, payload);
  },

  SET_VALUE: set('value')
};

export const actions: ActionTree<SnackbarState, SnackbarState> = {
  createSnack: ({ commit, state }, payload: SnackBarType) => {
    commit('SET_SNACKBAR', payload);
  }
};

export const getters = {};
